import { Perms } from "_enums/Perms";
import { useCurrentUser } from "_api/hooks/auth";

export function hasPerm(perms: Perms[]) {
    const { user } = useCurrentUser();

    return !(!!perms && !user.permissions?.some(p => perms.some(_ => _ == p)));
}

export function containPerms(perms: Perms[], userPerms: Perms[]) {

    return !(!!perms && !userPerms?.some(p => perms.some(_ => _ == p)));
}

export const HasPerm = ({ perms, children }: { perms: Perms[], children: React.ReactNode }) => {
    if (hasPerm(perms)) {
        return <>{children}</>;
    }
    return null;
}
